import { isMobile } from 'react-device-detect';
import NotMobileSupported from '../NotMobileSupported';

const MobileBlocker = ({ children }) => {
    if (isMobile) {
        return <NotMobileSupported />;
    }

    return children;
};

export default MobileBlocker;